// Theme Info Modal functionality
window.setupThemeInfoModal = function setupThemeInfoModal() {
    const modal = document.getElementById("themeInfoModal");
    const themeInfoContainer = document.querySelector(".abs-top-right");
    const closeBtn = document.getElementById("closeThemeInfo");

    if (!modal || !themeInfoContainer || !closeBtn) {
        // console.log("Theme info modal elements not found");
        return;
    }

    let isExpanded = false;

    // Function to expand the modal
    function expandModal() {
        if (isExpanded) return;

        isExpanded = true;
        themeInfoContainer.classList.add("expanded");
        
        // Prevent body scroll
        document.body.style.overflow = "hidden";
        
        // Prevent scroll on theme preview and card content
        const themePreview = document.getElementById("themePreview");
        const invitationCard = document.getElementById("invitationCard");
        const cardWrapper = document.querySelector(".card-wrapper");
        
        if (themePreview) {
            themePreview.classList.add("modal-open");
        }
        if (invitationCard) {
            invitationCard.classList.add("modal-open");
        }
        if (cardWrapper) {
            cardWrapper.classList.add("modal-open");
        }

        // Animate with GSAP for smooth transition
        gsap.to(modal, {
            duration: 0.4,
            ease: "power2.out",
        });
    }

    // Function to collapse the modal
    function collapseModal() {
        if (!isExpanded) return;

        isExpanded = false;
        themeInfoContainer.classList.remove("expanded");
        
        // Restore body scroll
        document.body.style.overflow = "";
        
        // Restore scroll on theme preview and card content
        const themePreview = document.getElementById("themePreview");
        const invitationCard = document.getElementById("invitationCard");
        const cardWrapper = document.querySelector(".card-wrapper");
        
        if (themePreview) {
            themePreview.classList.remove("modal-open");
        }
        if (invitationCard) {
            invitationCard.classList.remove("modal-open");
        }
        if (cardWrapper) {
            cardWrapper.classList.remove("modal-open");
        }

        // Animate with GSAP for smooth transition
        gsap.to(modal, {
            duration: 0.4,
            ease: "power2.out",
        });
    }

    // Click on modal to expand (when collapsed)
    modal.addEventListener("click", function (e) {
        // Don't expand if clicking on close button or edit button
        if (
            e.target.closest(".theme-info-close") ||
            e.target.closest(".theme-edit-btn")
        ) {
            return;
        }

        if (!isExpanded) {
            expandModal();
        }
    });

    // Close button click
    closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        collapseModal();
    });

    // Close on escape key
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && isExpanded) {
            collapseModal();
        }
    });
}
